import React from 'react';
import { HorizontalTabBar, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useFullFormPageStore } from 'store/pages/enrollment/add-employees/full-form/pageStore';
import { TabItem } from '@insurancemenu/imenu-components-lib/dist/types/HorizontalTabBar';
import { TabId } from 'store/modules/full-employee-form/types';
import { EmployeeProfileTab } from 'components/common/add-employees/full-form/EmployeeProfileTab';
import DependentsTab from 'components/common/add-employees/full-form/DependentsTab';
import ElectionsTab from './ElectionsTab';
import { SpinnerWrapperStyled } from './styles';
import { FULL_FORM_TABS_TEST_ID, FULL_FORM_SPINNER_TEST_ID } from '../constants';

export const FullFormTabs: React.FC = observer(() => {
  const pageStore = useFullFormPageStore();
  const {
    currentTabId,
    isInitialDataLoading,
    subscriberExists,
    employeeProfileTab,
    setCurrentTabId,
    electionsModule,
    isLoading,
  } = pageStore;

  const employeeProfileTabItem: TabItem = {
    id: 'employee-profile',
    label: 'Employee Profile',
    isValid: employeeProfileTab.isValid,
  };

  const dependentsTabItem: TabItem = {
    id: 'dependents',
    label: 'Dependents',
  };

  const electionsTabItem: TabItem = {
    id: 'elections',
    label: 'Elections',
    isValid: electionsModule?.subscribers.length > 0 ? electionsModule.subscribers[0]?.isSubscriberValid : true,
  };

  const tabsContent = {
    [TabId.EMPLOYEE_PROFILE]: <EmployeeProfileTab pageStore={pageStore} />,
    [TabId.DEPENDENTS]: <DependentsTab pageStore={pageStore} />,
    [TabId.ELECTIONS]: <ElectionsTab />,
  };

  return (
    <HorizontalTabBar
      tabs={[employeeProfileTabItem, dependentsTabItem, electionsTabItem]}
      activeTabId={currentTabId}
      setActiveTab={subscriberExists ? setCurrentTabId : undefined}
      data-test-id={FULL_FORM_TABS_TEST_ID}
    >
      <>
        {isInitialDataLoading ? (
          <SpinnerWrapperStyled data-test-id={FULL_FORM_SPINNER_TEST_ID}>
            <OverlaySpinner display />
          </SpinnerWrapperStyled>
        ) : (
          tabsContent[currentTabId]
        )}
        {isLoading && <OverlaySpinner display />}
      </>
    </HorizontalTabBar>
  );
});
